import Phaser from 'phaser';
import { getGameContext } from '../utils/context';
import { BGM, SFX } from '../audio/AudioKeys';
import { initSceneContext } from '../utils/initContext';

export class MainMenuScene extends Phaser.Scene {
    constructor() {
        super({ key: 'MainMenuScene' });
    }

    create() {
        // Ensure GameContext and SoundManager are initialized for this scene
        initSceneContext(this);

        // Try to play menu music (guarded by SoundManager for missing assets)
        try {
            const ctx = getGameContext(this);
            ctx.sound?.playMusic(BGM.Menu, { loop: true, fadeInMs: 500 });
        } catch {
            // context not ready yet; safe to ignore
        }

        // Display the loaded logo (if available)
        try {
            const logo = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 100, 'phaser-logo');
            logo.setOrigin(0.5);
            logo.setScale(0.5);
        } catch {
            // ignore if no logo asset
        }

        this.add.text(this.cameras.main.width / 2, this.cameras.main.height / 2, 'Main Menu', { fontSize: '64px', color: '#ffffff' }).setOrigin(0.5);
        const startButton = this.add.text(this.cameras.main.width / 2, this.cameras.main.height / 2 + 100, 'Start Game', { fontSize: '32px', color: '#ffffff' }).setOrigin(0.5);
        startButton.setInteractive();

        startButton.on('pointerover', () => {
            startButton.setColor('#ff0'); // Change color on hover
        });

        startButton.on('pointerout', () => {
            startButton.setColor('#fff'); // Revert color when not hovered
        });

        startButton.on('pointerdown', () => {
            // Click SFX
            try {
                const ctx = getGameContext(this);
                ctx.sound?.playSfx(SFX.UiClick);
            } catch {}
            this.scene.start('GameScene');
        });

        // Optional: allow pressing ENTER to start as well
        const kb = this.input.keyboard;
        if (kb) {
            const enter = kb.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER);
            enter.once('down', () => {
                try {
                    const ctx = getGameContext(this);
                    ctx.sound?.playSfx(SFX.UiClick);
                } catch {}
                this.scene.start('GameScene');
            });
        }
    }
}
